export enum FileType {
  Pdf = 'application/pdf',
  Png = 'image/png',
  Jpeg = 'image/jpeg',
  Jpg = 'image/jpg',
  Heic = 'image/heic',
  Heif = 'image/heif'
}
